(() => {
  if (window.arenaPurchaseInstalled) return;
  window.arenaPurchaseInstalled = true;
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.aa-product__form') || !window.fetch) return;
    const button = form.querySelector('[name="add"]');
    if (!button || button.disabled || form.dataset.pending === 'true') { event.preventDefault(); return; }
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    event.preventDefault();
    const status = form.querySelector('[data-arena-add-status]');
    const originalText = button.textContent;
    const data = new FormData(form);
    data.set('sections', 'cart-drawer,cart-icon-bubble');
    data.set('sections_url', window.location.pathname);
    form.dataset.pending = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = status?.dataset.adding || originalText;
    if (status) { status.dataset.state = 'loading'; status.textContent = status.dataset.adding; }
    const sticky = form.closest('[data-aa-product]')?.querySelector('[data-sticky-add]');
    if (sticky) sticky.disabled = true;
    let added = false;
    try {
      const response = await fetch(form.action.replace(/\/$/, '') + '.js', {method:'POST',body:data,headers:{Accept:'application/json'},credentials:'same-origin'});
      const result = await response.json();
      if (!response.ok || result.status) {
        const error = new Error();
        error.cartMessage = typeof result.description === 'string' ? result.description : status?.dataset.error;
        throw error;
      }
      added = true;
      if (status) { status.dataset.state = 'success'; status.textContent = status.dataset.added; }
      if (!result.sections?.['cart-drawer'] || !result.sections?.['cart-icon-bubble']) { window.location.assign(window.routes.cart_url); return; }
      drawer.classList.remove('is-empty');
      drawer.setActiveElement(button);
      drawer.renderContents(result);
    } catch (error) {
      if (added) { window.location.assign(window.routes.cart_url); return; }
      if (status) { status.dataset.state = 'error'; status.textContent = error.cartMessage || status.dataset.error; }
    } finally {
      form.dataset.pending = 'false';
      form.removeAttribute('aria-busy');
      button.disabled = false;
      button.textContent = originalText;
      if (sticky) sticky.disabled = false;
    }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('.aa-product__form [data-variant]')) return;
    const select = event.target, form = select.closest('form'), root = select.closest('[data-aa-product]');
    const option = select.selectedOptions[0], button = form.querySelector('[name="add"]'), sticky = root?.querySelector('[data-sticky-add]');
    if (option && button && form.dataset.pending !== 'true') {
      button.disabled = option.disabled;
      if (sticky) sticky.disabled = option.disabled;
      const stickyPrice = root?.querySelector('[data-sticky]>b');
      if (stickyPrice && option.dataset.price) stickyPrice.textContent = option.dataset.price;
    }
  });
})();
